// @flow

type SetWithSearchHeroAction = {
  type: 'SET_WITH_SEARCH_HERO',
  payload: {
    withSearchHero: boolean
  }
};

export const setWithSearchHero = (
  withSearchHero: boolean
): SetWithSearchHeroAction => ({
  type: 'SET_WITH_SEARCH_HERO',
  payload: {
    withSearchHero
  }
});

type SetHadResumeDatabaseAdType = {
  type: 'SET_HAD_RESUME_DATABASE_AD',
  payload: {
    hadResumeDatabaseAd: boolean
  }
};

export const setHadResumeDatabaseAd = (
  hadResumeDatabaseAd: boolean
): SetHadResumeDatabaseAdType => ({
  type: 'SET_HAD_RESUME_DATABASE_AD',
  payload: {
    hadResumeDatabaseAd
  }
});

type SetHideSalarySurveyAdType = {
  type: 'SET_HIDE_SALARY_SURVEY_AD',
  payload: {
    hideSalarySurveyAd: boolean
  }
};

export const setHideSalarySurveyAd = (
  hideSalarySurveyAd: boolean
): SetHideSalarySurveyAdType => ({
  type: 'SET_HIDE_SALARY_SURVEY_AD',
  payload: {
    hideSalarySurveyAd
  }
});

export type Action =
  | SetWithSearchHeroAction
  | SetHideSalarySurveyAdType
  | SetHadResumeDatabaseAdType;
